import React, { PureComponent } from "react";
import ExpandButton from "./expand-button";
import CollapseButton from "./collapse-button";
import ExpandWidget from "./expand-widget";
import CollapseWidget from "./collapse-widget";

class ExpandCollapsePage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExpand: false,
      showModal: false
    };
  }

  showModal = () => {
    this.setState({
      showModal: true
    });
  };

  hideModal = () => {
    this.setState({
      showModal: false
    });
  };

  handleExpandClick = () =>
    this.setState({
      isExpand: true
    });
  handleCollapseClick = () =>
    this.setState({
      isExpand: false
    });

  get showEditModal() {
    const {
      roundInUrl,
      currentRound,
      rounds,
      hasAccess,
      roundShouldBeFinished
    } = this.props;

    if (hasAccess === false) {
      return false;
    }

    if (roundShouldBeFinished === true) {
      return false;
    }

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  renderButton() {
    const { isExpand } = this.state;

    if (isExpand === true) {
      return <CollapseButton onClick={this.handleCollapseClick} />;
    }

    return <ExpandButton onClick={this.handleExpandClick} />;
  }

  renderContent() {
    const {
      projections,
      currentRound,
      roundInUrl,
      rounds,
      reloadData,
      hasAccess,
      showRoleAlert,
      tourMode,
      roundShouldBeFinished
    } = this.props;
    const { isExpand } = this.state;

    if (isExpand === true) {
      return (
        <ExpandWidget
          projections={projections}
          currentRound={currentRound}
          roundInUrl={roundInUrl}
        />
      );
    }

    return (
      <CollapseWidget
        projections={projections}
        rounds={rounds}
        onSave={reloadData}
        hasAccess={hasAccess}
        showRoleAlert={showRoleAlert}
        currentRound={currentRound}
        roundInUrl={roundInUrl}
        tourMode={tourMode}
        roundShouldBeFinished={roundShouldBeFinished}
        showModalState={this.state.showModal}
        showModal={this.showModal}
        hideModal={this.hideModal}
      />
    );
  }

  render() {
    const { loaded } = this.props;

    return (
      <div>
        {loaded === true ? (
          <div>
            {!this.state.showModal && (
              <div
                id="ceo-decisions-financial-projections"
                className="border report-collapse"
              >
                <h2 className="semibold">
                  1-Year Financial Projection
                  {this.renderButton()}
                </h2>
                {this.renderContent()}
              </div>
            )}
            {this.state.showModal && this.renderContent()}
          </div>
        ) : (
          <div className="loader_spinner">Loading...</div>
        )}
      </div>
    );
  }
}

export default ExpandCollapsePage;



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/expand-collapse-page.js